import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'

import { APIURL } from '/constants'
import PageTitle from '/components/common/PageTitle'
import services from '/components/services'
import DefaultLayout from '/components/layouts/DefaultLayout'
import ProductDetailsDisplay from '/components/marketplace/ProductDetailsDisplay'
import ProductDetailsLoading from '/components/marketplace/ProductDetailsLoading'
import { withPageConditions } from '/components/utils'

const ProductDetails = (props) => {
  const product = props.data.response
  if (!props.data || !props.data.response) {
    return <ProductDetailsLoading />
  }

  return (
    <div>
      <PageTitle
        title={`${product.page_title || product.product_name || ''}`}
        description={`${
          product.meta_description || product.description_short || ''
        }`}
        imageUrl={product?.hero_media?.media_website}
      />
      <Head>
        <meta
          property="twitter:title"
          content={`${product.page_title || product.product_name || ''}`}
        />
        <meta
          property="twitter:description"
          content={`${
            product.meta_description || product.description_short || ''
          }`}
        />
        <meta
          property="og:title"
          content={`${product.page_title || product.product_name || ''}`}
        />
        <meta
          property="og:description"
          content={`${
            product.meta_description || product.description_short || ''
          }`}
        />
        <meta property="og:type" content={'product'} />
        <meta
          property="description"
          content={`${
            product.meta_description || product.description_short || ''
          }`}
        />
      </Head>
      <ProductDetailsDisplay
        product={product}
        productUserData={props.productUserData}
      />
    </div>
  )
}

ProductDetails.propTypes = {
  store: PropTypes.object,
  data: PropTypes.object,
  integration: PropTypes.object
}

ProductDetails.Layout = DefaultLayout

export const getServerSideProps = withPageConditions(
  async (ctx, siteData, profile) => {
    const { host } = ctx.req.headers
    const { slug } = ctx.query
    const cookie = ctx.req.headers.cookie || null
    const data = await services.get_v2(
      APIURL.API_MARKETPLACE_DETAIL(slug),
      {},
      host,
      cookie
    )

    const productUserData = await services.get_v2(
      APIURL.API_PRODUCT_USER_INFO(slug),
      {},
      host,
      cookie
    )

    if (data.statusCode !== 200) {
      return {
        notFound: true
      }
    }

    if (!profile && data?.response?.required_authentication) {
      return {
        redirect: {
          destination: '/login/?next=' + ctx.req.path,
          permanent: false
        }
      }
    }

    return {
      props: {
        data,
        productUserData: productUserData?.response || null
      }
    }
  }
)

export default ProductDetails
